import { createSlice } from "@reduxjs/toolkit";
import { convertArrayToObject, groupDataByKey } from "../../helpers/catalog-helper";

export type InventorySupplierType = {
  additionalInfo: Record<string, string>;
  address: Record<string, any>;
  branchId: string;
  channelDefId: string;
  createTaxInvoice: boolean;
  createdBy: string;
  createdDate: string;
  isNegotiable: boolean;
  lastModifiedBy: string;
  lastModifiedDate: string;
  mid: string;
  status: string;
  supplierCode: string;
  supplierName: string;
  type: string;
  version: number;
}
export interface BusinessState {
  isBusinessDataFetching: boolean,
  isUserDataFetching: boolean,
  isFetchingData: boolean,
  businessData: {},
  userData: {},
  branchGroups: {};
  allChannelsData: [];
  allBrandsData: [];
  allChannelsDataMap: {};
  allChannelsDefDataMap: {};
  businessBranchesDataMap: {};
  brancheByBranchGroup: {}; //it will have all the channels for a particular group
  channelsByBranchGroup: {};
  businessBranchesData: [],
  inventoryBranchesData: {},
  permittedInventoryBranches: [];
  resourceGroups: {};
  licences: { licenceCode: string }[];
  midDetail: string,
  inventorySuppliers: InventorySupplierType[]
}

const initialState: BusinessState = {
  isBusinessDataFetching: false,
  isUserDataFetching: false,
  isFetchingData: false,
  businessData: {},
  userData: {},
  businessBranchesData: [],
  businessBranchesDataMap: {},
  inventoryBranchesData: {},
  branchGroups: {},
  allChannelsData: [],
  allChannelsDataMap: {},
  allChannelsDefDataMap: {},
  allBrandsData: [],
  brancheByBranchGroup: {},
  channelsByBranchGroup: {},
  permittedInventoryBranches: [],
  resourceGroups: {},
  midDetail: '',
  licences: [],
  inventorySuppliers: []
}

export const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getBusinessData: (state) => {
      state.isBusinessDataFetching = true;
    },
    saveBusinessData: (state, action) => {
      state.isBusinessDataFetching = false;
      state.businessData = action.payload;
    },
    getBusinessDataObjFailure: (state) => {
      state.isBusinessDataFetching = false;
    },
    getUserDataObj: (state, actions) => {
      state.isUserDataFetching = true;
    },
    saveUserData: (state, action) => {
      state.isUserDataFetching = false;
      state.userData = action.payload;
    },
    getUserDataObjFailure: (state) => {
      state.isUserDataFetching = false;
    },
    getBusinessBranchesData: (state) => {
      state.isFetchingData = true;
    },
    saveBusinessBranchesData: (state, action) => {
      state.businessBranchesData = action.payload;
      state.businessBranchesDataMap = convertArrayToObject(action.payload, "branchId");
      state.brancheByBranchGroup = groupDataByKey(action.payload, "groupId");
      state.isFetchingData = false;
    },
    getInventorySuppliers: (state) => {
      state.isFetchingData = true;
    },
    getInventoryBranchesData: (state) => {
      state.isFetchingData = true;
    },
    saveInventorySuppliers: (state, action) => {
      state.inventorySuppliers = action.payload?.results || [];
      state.isFetchingData = false;
    },
    saveInventoryBranchesData: (state, action) => {
      state.inventoryBranchesData = action.payload;
      state.isFetchingData = false;
    },
    savePermittedInventoryBranches: (state, action) => {
      state.permittedInventoryBranches = action.payload;
    },
    getBranchesGroupData: (state) => {
      state.isFetchingData = true;
    },
    saveBranchesGroupData: (state, action) => {
      state.branchGroups = convertArrayToObject(action.payload, "groupId");
      state.isFetchingData = false;
    },
    saveResourceGroupData: (state, action) => {
      state.resourceGroups = action.payload ;
      state.isFetchingData = false;
    },
    getAllChannels: (state) => {
      state.isFetchingData = true;
    },
    saveAllChannelsData: (state, action) => {
      state.allChannelsData = action.payload;
      state.allChannelsDataMap = convertArrayToObject(action.payload, "channelId");
      state.allChannelsDefDataMap = convertArrayToObject(action.payload, "channelDefId");
      state.channelsByBranchGroup = groupDataByKey(action.payload, "groupId");
      state.isFetchingData = false;
    },
    getAllBrands: (state) => {
      state.isFetchingData = true;
    },
    saveAllBrandsData: (state, action) => {
      state.allBrandsData = action.payload;
      state.isFetchingData = false;
    },
    saveUserMid: (state, action) => {
      state.midDetail = action.payload
    },
    getLicencesForBusiness: (state) => {
      state.isFetchingData = true;
    },
    saveLicencesForBusiness: (state, action) => {
      state.licences = action.payload;
      state.isFetchingData = false;
    },
  }
})

export const {
  saveLicencesForBusiness,
  getLicencesForBusiness,
  getBusinessData,
  getBusinessDataObjFailure,
  getUserDataObj,
  getUserDataObjFailure,
  getBusinessBranchesData,
  getInventoryBranchesData,
  saveBusinessBranchesData,
  saveInventoryBranchesData,
  saveUserData,
  saveBusinessData,
  getBranchesGroupData,
  saveBranchesGroupData,
  getAllChannels,
  saveAllChannelsData,
  getAllBrands,
  saveAllBrandsData,
  savePermittedInventoryBranches,
  saveResourceGroupData,
  saveUserMid,
  getInventorySuppliers,
  saveInventorySuppliers,
} = businessSlice.actions;
export default businessSlice.reducer;